import {
  loginTenant,
  pickTenant,
  localLogin,
  generateUserLoginKey,
  changeTenant
} from '../../api/user.api'
import { parseJwt } from '../../plugins/jwtParser'
import i18n from '@/plugins/i18n'
import { globalConstants } from '../../utils/globalConstants'

export const namespaced = true

export const state = {
  user: null,
  tenants: null,
  errorLogin: null,
  userDecoded: null,
  isUserDriverRole: false
}

export const mutations = {
  SET_USER_DATA(state, userData) {
    state.user = userData
    localStorage.setItem('user', JSON.stringify(userData))
    state.userDecoded = state.user.accessToken
      ? parseJwt(state.user.accessToken.split('.')[1])
      : null
    state.isUserDriverRole = JSON.parse(state.userDecoded.UserData).RoleName == globalConstants.driverRoleName
  },
  SET_TENANTS(state, tenants) {
    state.tenants = tenants
    localStorage.setItem('tenants', JSON.stringify(tenants))
  },
  SET_LOGIN_KEY(state, key) {
    state.loginKey = key
  },
  CLEAR_USER_DATA() {
    localStorage.removeItem('user')
  },
  SET_ERROR_LOGIN(state, payload) {
    state.errorLogin = payload
  }
}
export const actions = {
  register({ commit, dispatch }, credentials) {
    return post(credentials)
      .then(({ data }) => {
        commit('SET_USER_DATA', data)
      })
      .catch(error => {
        commit('CLEAR_USER_DATA')
        const notification = {
          type: 'error',
          message: error
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  login({ commit, dispatch }, credentials) {
    return loginTenant(credentials)
      .then(({ data }) => {
        commit('SET_TENANTS', data)
      })
      .catch(e => {
        console.log(e)
        const notification = {
          type: 'error',
          message: 'Invalid credentials. Please try again.'
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  localLoginAction({ commit, dispatch }, credentials) {
    return generateUserLoginKey(credentials)
      .then(({ data }) => {
        if (data.isAdmin) {
          commit('SET_TENANTS', data.tenants)
          commit('SET_LOGIN_KEY', data.loginKey)
        } else {
          return localLogin({ loginKey: data.loginKey, tenantId: null, savePassword: credentials.savePassword })
            .then(({ data }) => {
              commit('SET_USER_DATA', data)
            })
            .catch(e => {
              const notification = {
                type: 'error',
                message: 'Invalid credentials. Please try again.'
              }
              dispatch('notification/add', notification, { root: true })
            })
        }
      })
      .catch(e => {
        let message
        switch (e.response.status) {
          case 409:
            message = i18n.t('inactiveTenant')
            break
          default:
            message = i18n.t('invalidCredentials')
            break
        }
        const notification = {
          type: 'error',
          message: message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  localTenantAuth({ commit, dispatch }, loginItem) {
    return localLogin(loginItem)
      .then(({ data }) => {
        commit('SET_USER_DATA', data)

        let tenants = JSON.parse(localStorage.getItem('tenants'))
        let selectedTenant = tenants.filter(
          x => x.tenantId == loginItem.tenantId
        )[0]

        commit('SET_TENANTS', {
          SelectedTenant: selectedTenant,
          AvailableTenants: tenants
        })
      })
      .catch(e => {
        const notification = {
          type: 'error',
          message: 'Invalid credentials. Please try again.'
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  changeTenant({ commit, dispatch }, tenantUserToken) {
    return changeTenant(tenantUserToken)
      .then(({ data }) => {
        commit('CLEAR_USER_DATA')

        commit('SET_USER_DATA', data)

        let tenants = JSON.parse(localStorage.getItem('tenants'))
          .AvailableTenants
        let selectedTenant = tenants.filter(
          x => x.tenantId == tenantUserToken.tenantId
        )[0]

        commit('SET_TENANTS', {
          SelectedTenant: selectedTenant,
          AvailableTenants: tenants
        })

        location.reload()
      })
      .catch(e => {
        const notification = {
          type: 'error',
          message: "Server error, couldn't change tenant."
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  pickTenant({ commit, dispatch }, tenant) {
    return pickTenant(tenant)
      .then(({ data }) => {
        commit('SET_USER_DATA', data)
      })
      .catch(e => {
        commit('SET_ERROR_LOGIN', true)
        commit('CLEAR_USER_DATA')
        const notification = {
          type: 'error',
          message: 'Something went wrong during login process.'
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  clearTenants({ commit }) {
    commit('SET_TENANTS', null)
  },
  logout({ commit }) {
    commit('CLEAR_USER_DATA')
  }
}
export const getters = {
  loggedIn(state) {
    return !!state.user
  },
  jwt: state => {
    if (state.user != null) {
      return state.user.accessToken
    }
    return null
  },
  jwtData: (state, getters) => {
    if (state.user != null) {
      return state.user.accessToken ? parseJwt(getters.jwt.split('.')[1]) : null
    }
    return null
  },
  jwtUser: (state, getters) =>
    getters.jwtData ? getters.jwtData.Username : null,
  tenants: state => state.tenants,
  isDriverRole: (state, getters) => JSON.parse(getters.jwtData.UserData).RoleName == globalConstants.driverRoleName
}
